import React from "react";
import { Row } from "reactstrap";
import { ColValue } from "../ProductionModule/index";
import { ColPrompt, RadioLabelCol } from "./index";
// Used on the Mahan Oven

export default function MinMaxTrueFalseRow({
   titleProp,
   descriptionProp = "",
   valueProp1 = "true",
   valueProp2 = "false",
   differentDisplayProp1 = "Top:",
   differentDisplayProp2 = "Bottom:",
   onChangeProp1,
   onChangeProp2,
   groupNameProp1,
   groupNameProp2,
}) {

   return (
      <Row className="mb-2">
         <ColPrompt title={titleProp} bold={true} description={descriptionProp} />
         <ColValue size={2}>
            {differentDisplayProp1}&nbsp;&nbsp;
            <RadioLabelCol groupNameProp={groupNameProp1} valueProp={valueProp1} onChangeProp={onChangeProp1} displayProp={"On"} trueFalseProp />
            <RadioLabelCol groupNameProp={groupNameProp1} valueProp={valueProp2} onChangeProp={onChangeProp1} displayProp={"Off"} trueFalseProp />
         </ColValue>
         <ColValue size={2}>
            {differentDisplayProp2}&nbsp;&nbsp;
            <RadioLabelCol groupNameProp={groupNameProp2} valueProp={valueProp1} onChangeProp={onChangeProp2} displayProp={"On"} trueFalseProp />
            <RadioLabelCol groupNameProp={groupNameProp2} valueProp={valueProp2} onChangeProp={onChangeProp2} displayProp={"Off"} trueFalseProp />
         </ColValue>
      </Row>
   );
}
